import { useEventCallback } from "hooks/useEventCallback";
import { bindAction } from "interfaces";
import { useCallback, useRef, useState } from "react";
import { connect, type ConnectedProps } from "react-redux";
import FormFooter from "../../../../components/forms/FormFooter";
import { type AppDispatch, type RootState } from "../../../Application/globaltypes/redux";
import { type EnrollmentRule } from "../../Groups/AddEditGroupForms/EnrollmentBuilder/utils";
import { GroupTemplateEnrollment } from "../Details/GroupTemplateEnrollment";
import { saveRulesAction } from "../state/thunks/TemplateEnrollmentThunk";

type Props = {
  disabled: boolean;
  templateId: number;
};

type AllProps = Props & PropsFromRedux;

const EditTemplateEnrollment = (props: AllProps) => {
  const { disabled, enrollmentRules, templateUsersOnly, templateId, saveRules, accountType } = props;
  const [isValid, setIsValid] = useState(true);
  const getValuesRef = useRef<() => { enrollmentRules: EnrollmentRule[]; templateUsersOnly: boolean | null }>(() => ({
    enrollmentRules,
    templateUsersOnly,
  }));
  const [isDirty, setIsDirty] = useState(false);
  const resetFormRef = useRef<() => void>(() => {});

  const save = useEventCallback(async () => {
    const currentValues = getValuesRef.current?.();
    const currentEnrollmentRules = currentValues.enrollmentRules;
    const currentTemplateUsersOnly = currentValues.templateUsersOnly;
    await saveRules(templateId, currentEnrollmentRules, currentTemplateUsersOnly);
  }, [saveRules, templateId]);

  const onCancel = useCallback(() => {
    resetFormRef.current();
  }, []);

  return (
    <>
      <div className="scrollable-content">
        <GroupTemplateEnrollment
          disabled={disabled}
          bindGetValues={(getValues) => (getValuesRef.current = getValues)}
          enrollmentRules={enrollmentRules}
          templateUsersOnly={templateUsersOnly}
          onIsValidChange={setIsValid}
          onIsDirtyChange={setIsDirty}
          accountType={accountType}
          bindFormReset={(resetForm) => (resetFormRef.current = resetForm)}
        />
      </div>
      {disabled || (
        <FormFooter
          isSaveBtnDisabled={!(isDirty && isValid)}
          isCancelBtnDisabled={!isDirty}
          onSave={save}
          onCancel={onCancel}
        />
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  const { groupTemplate } = state.people;
  return {
    enrollmentRules: groupTemplate.base.enrollmentRules,
    templateUsersOnly: groupTemplate.base.templateUsersOnly,
    accountType: state.userProfile.accountTypeId,
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    saveRules: bindAction(saveRulesAction, dispatch),
  };
};
const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

const ConnectedComponent = connector(EditTemplateEnrollment);
export default ConnectedComponent;
